module.exports = __webpack_public_path__ + "img/Nicaragua.c0f57c2e.png";